export const environment = {
    production: true,
    CompanyInfo:{
        CompanyName:                  "ShieldSafe",
        DisplayedPhoneNumber:         "1-800-868-5661",
        CompanyId :                   7,
        SaleEndpoint:                 "SafeSale2",
        PrivacyLink:                  "https://shieldsafe.com/privacy.asp",
        TermsLink:                    "https://shieldsafe.com/terms.asp",
        CustomerServicePhoneDisplay:  "800-856-8118",
        CancelURL:                    "https://share.hsforms.com/13IJvC9wGSRSqgXzM3OgLgQe0jkj",
        OptOutURL:                    "https://share.hsforms.com/1sCfgC0nYTNOsU0wxtPVjFge0jkj",
        PersonalInfoOptOutURL:        "https://share.hsforms.com/1lVF-V4P6RzalMzx-7WoVlQe0jkj",
        SummaryOfBenefitsLink:        "https://imc2-prestaging.csid.co/p/OTAwMDAxNzIz/media/Summary_of_Benefits_June_2019.pdf",
        EmailContactLink:             "cst@shieldsafe.com",
        FortePromoCode:               "SSDIRECT",
        CancelServiceFormUrl:         "https://share.hsforms.com/13IJvC9wGSRSqgXzM3OgLgQe0jkj",
        AgilityContentModel:          178,
        AgilityHeaderLogo:            "https://cdn.aglty.io/carshield/direct-sites/shieldsafe/ShieldSafeLogo.png?format=auto",
        AgilityHeaderLogoMobile:      "https://cdn.aglty.io/carshield/direct-sites/shieldsafe/ShieldSafeLogo_45x45.png?format=auto",
        AgilityFavIcon:               "https://cdn.aglty.io/carshield/direct-sites/shieldsafe/favicon.png?format=auto",
        AssociatedCompanyBranding:    "/assets/ShieldSafe/logo/experian-64px.png",
        BrandingUnderCart:            "/assets/Icons/EXP-data-provided-by.svg"
    },

    ConnectionInfo: {
        apiUrl:               "https://api.carshielddirect.com/", 
        localDebug:           "false",
        MediaPageURL:         "https://shieldsafe.com/shield-direct/index.html",
        paymentTesting:       "false",
        generatePlansFromApi: "false",
        middleTierUrl:        "https://webapi.carshield.com:5120/",
        middleTierBearer:     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IlF1aWNrUGF5U2VyaXZjZUFjY291bnQiLCJyb2xlIjpbIlF1aWNrcGF5IiwiQWdpbGl0eSJdLCJuYmYiOjE3MzIyMjA1MzMsImV4cCI6MTczMjIyMTQzMywiaWF0IjoxNzMyMjIwNTMzLCJpc3MiOiJDYXJTaGllbGQiLCJhdWQiOiJBUEkifQ.WjFxhEYRWHhb0UTSnq3aa_5DcgnwYFXAmkGNmok8zXY"
    },

    BottomFieldTipsText:[
        "ID fraud: 15 million victims in 2023",
        "Children: 51x more fulnerable to ID theft",
        "2023: average of $1,520 stolen per victim",
        "Guaranteed Locked-in Pricing"
    ],

    LegalData:[
        {
            legalName:    "Payment Terms",
            legalRef:     "terms",
            legalText:    "By clicking Submit Payment, you authorize Lira Processing, LLC and Experian to use, on a recurring basis, your personal information for membership purposes, including accessing credit profiles and providing personalized offers. You confirm the accuracy of your information, your identity, and being at least 18 years old. Additionally, you agree to the automatic monthly renewal at $$_$ and the Terms of Service."
        },
        {
            legalName:    "Privacy Policy",
            legalRef:     "privacy",
            legalText:    "This is the privacy policy"
        },
        {
            legalName:    "Refund Policy",
            legalRef:     "refund",
            legalText:    "This is the refund policy"
        },
        {
            legalName:    "Consent to Contact",
            legalRef:     "contact",
            legalText:    "By clicking \"Next\", you allow $_$ to contact you by phone, text, or email to discuss coverage options or future promotions."
        }
    ],

    PageNotes:[
        {
            PageRef:  "checkout",
            PageNote: "Upon purchase, you will receive a payment confirmation email and an email with instructions on how to activate your protection in the customer portal."
        }
    ],

    Google:{
        googleAddressValidationUrl: "https://addressvalidation.googleapis.com/v1:validateAddress?key=",
        googleAddressValidationKey: "AIzaSyCNA5F1M0Qe0sy1RdT9xj0DhkF1iS3Cpdo"
    }
};